import { SUPPORTED_LANGUAGES } from './constants';

export function splitMarkdownCodeBlocks(content: string): string[] {
  const parts: string[] = [];
  let lastIndex = 0;
  const regex = /```([A-Za-z]+)([\s\S]*?)```/g;

  let match;
  while ((match = regex.exec(content)) !== null) {
    const [fullMatch, lang] = match;
    if (!SUPPORTED_LANGUAGES.includes(lang)) {
      continue; // Skip invalid language blocks
    }

    // Add text before code block
    if (match.index > lastIndex) {
      parts.push(content.slice(lastIndex, match.index));
    }
    parts.push(fullMatch);
    lastIndex = match.index + fullMatch.length;
  }

  // Add remaining text
  if (lastIndex < content.length) {
    parts.push(content.slice(lastIndex));
  }

  return parts.length > 0 ? parts : [content];
}
